import clsx from 'clsx';

import { selectedTab, tab, tabs } from './tabs.css';

type TabsProps<T> = {
  data: T[];
  selected: string;
  label: (el: T) => string;
  value: (el: T) => string;
  onSelect: (el: T) => void;
  classNames?: { tabs?: string; tab?: string; selectedTab?: string };
};

export function Tabs<T>({
  data,
  selected,
  onSelect,
  label,
  value,
  classNames,
}: TabsProps<T>) {
  return (
    <section className={clsx(tabs, classNames?.tabs)}>
      {data.map((el) => (
        <button
          className={clsx(tab, classNames?.tab, {
            [selectedTab]: value(el) === selected,
          })}
          disabled={value(el) === selected}
          key={value(el)}
          onClick={(e) => {
            e.preventDefault();
            onSelect(el);
          }}
        >
          {label(el)}
        </button>
      ))}
    </section>
  );
}
